import { FC, PropsWithChildren } from 'react';

import { SnackbarProvider as NotistackProvider } from 'notistack';

import { useStyles } from './styles';

const SnackbarProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const classes = useStyles();

  return (
    <NotistackProvider
      preventDuplicate
      disableWindowBlurListener
      classes={{
        variantError: classes.error,
        variantSuccess: classes.success,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
    >
      {children}
    </NotistackProvider>
  );
};

export default SnackbarProvider;
